<template>
  <div id="DopasujCentrale">
    <h3>{{$t('message.dopasowanie_centrali')}}</h3>
    <div v-if="selectedElements && selectedElements.obudowa && Object.keys(selectedElements.obudowa.rzuty).length > 1">
      {{$t('message.widok')}}:
      <ul class="navView">
        <li v-for="rzut in selectedElements.obudowa.rzuty" :key="rzut" @click="zmienWidok(rzut)"
        :class="(rzut === widok) ? 'activeView' : ''"
        >{{buttonText[rzut]}}</li>
      </ul>
    </div>

    <div style="max-width: 1200px; margin: 0px auto; display: inline-flex">
      <div class="kolumna-1">

        <fieldset>
          <legend style="width: 160px">{{$t('message.obudowa')}}</legend>
          <div style="margin: 20px 0px">
            <div class="md-layout-item">
              <!-- <h3>Obudowa</h3> -->
              <multiselect
                v-model="selectedObudowa"
                :options="obudowy"
                :multiple="false"
                label="symbol"
                track-by=""
                :placeholder="$t('message.obudowa').toLowerCase()"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                :showNoResults="false"
                @input="setObudowa()"
              >
              </multiselect>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend style="width: 190px">{{$t('message.centrala_moduly')}}</legend>
          <div class="md-layout-item">
            <!-- <h3>Producent</h3> -->
            <multiselect
              v-model="inputFields.producent"
              :options="Dystrybutorzy"
              :multiple="false"
              label=""
              track-by=""
                :placeholder="$t('message.producent').toLowerCase()"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              :showNoResults="false"
              :allow-empty="false"
              @input="clickProducent()"
              :disabled="isDisabled"
              :class="'inputSelectProducent'"
            >
            </multiselect>
          </div>

          <div class="md-layout-item inSelect">
            <multiselect
              v-model="inputFields.centrala"
              :options="centraleLista"
              :multiple="false"
              label="model"
                :placeholder="$t('message.centrala').toLowerCase()"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              :clear-on-select="true"
              :close-on-select="true"
              :showNoResults="false"
              :allow-empty="false"
              @input="clickCentrale($event)"
              :disabled="isDisabled"
              :class="
                Object.keys(inputFields.centrala).length > 0
                  ? 'inputSelectCentrala'
                  : 'inputSelectProducent'
              "
            >
            </multiselect>

            <div v-if="Object.keys(inputFields.centrala).length > 0" @click="clickEye('centrala')" class="oko">
              <svg
                v-if="!eyes.includes('centrala')"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-eye-fill"
                viewBox="0 0 16 16"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path
                  d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-eye-slash"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                />
                <path
                  d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                />
              </svg>
            </div>
          </div>

          <div
            class="md-layout-item inSelect"
            v-for="(mod, indexMod) in countBoxModules"
            :key="indexMod"
          >
            <multiselect
              v-model="inputFields.moduly[indexMod]"
              :options="modulyLista"
              :multiple="false"
              label="model"
                :placeholder="$t('message.modul').toLowerCase()"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              :showNoResults="false"
              :allow-empty="false"
              @input="clickModul($event)"
              :disabled="isDisabled"
              :class="
                inputFields.moduly[indexMod]
                  ? 'inputSelect' + indexMod
                  : 'inputSelectProducent'
              "
            >
            </multiselect>
            <div
              v-if="inputFields.moduly[indexMod]"
              class="oko"
              @click="clickEye('modul-' + indexMod)"
            >
              <svg
                v-if="!eyes.includes('modul-' + indexMod)"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-eye-fill"
                viewBox="0 0 16 16"
                style="cursor: point"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path
                  d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-eye-slash"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                />
                <path
                  d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                />
              </svg>
            </div>

          </div>

          <button
            class="btn btn-success"
            @click="addModul()"
            v-if="Object.keys(inputFields.moduly).length > 0"
            :disabled="countBoxModules === 4 ? true : false"
            style="
              margin: 8px 2px;
              width: 37px;
              height: 25px;
              line-height: 10px;
              float: right;
              font-weight: bold;
              font-size: 21px;
              border-radius: 0px;
            "
          >
            +
          </button>
          <button
            class="btn btn-danger"
            @click="deleteModul()"
            v-if="countBoxModules > 1"
            style="
              margin: 8px 2px;
              width: 37px;
              height: 25px;
              line-height: 10px;
              float: right;
              font-weight: bold;
              font-size: 21px;
              border-radius: 0px;
            "
          >
            -
          </button>
        </fieldset>

      </div>

      <div class="kolumna-2">

        <div>
          <Wizualizacja :eyes="eyes" :widokBtn='widokBtn' :widok='widok'/>
        </div>

        <div v-if="Object.keys(selectedObudowa).length > 0" style="text-align: left">
          <h3 style="font-size: 14px">
           {{$t('message.strona_produktowa')}}
            <a :href="'https://www.pulsar.pl/PL_9999_' + selectedObudowa.symbol + '_wyszukiwarka'" target="_new">{{$t('message.zobacz')}}</a>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { app } from "../mixins/functions";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

import Wizualizacja from "./Wizualizacja";

export default {
  name: "DopasujCentrale",
  mixins: [app],
  // props: ["tabName"],
  data() {
    return {
      selectedObudowa: [],
      selectedModul: [],
      // selectedModuly: [],
      selectedCentrala: [],
      // // centralaIndex: null,
      // // centralaProducent: null,
      isDisabled: true,
      // outputElements: {
      //   obudowy: [],
      // },
      inputFields: {
        producent: "",
        centrala: [],
        moduly: [],
      },
      additional: [],
      checkRerfresh: 0,
      countBoxModules: 1,
      eyes: []
    };
  },
  watch: {
    obudowy(newValue, oldValue) {
      // this.showView(newValue[0])
    },
  },
  components: {
    Multiselect,
    Wizualizacja
  },
  watch: {
    selectedObudowa (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isDisabled = false
      }
    }
  },
  computed: {
    ...mapGetters("products", [
      "centrale",
      "obudowy",
      "moduly",
      "selectedElements",
      "filters",
    ]),
  },
  methods: {
    showView(obudowa) {
      this.selectedObudowa = obudowa;
    },
    clickEye(item) {
      if (this.eyes.includes(item)) {
        var index = this.eyes.indexOf(item);
        if (index !== -1) {
          this.eyes.splice(index, 1);
        }
      } else {
        this.eyes.push(item);
      }
      // console.log('eyes', this.eyes)
    },
    clickProducent() {
      console.log("------ clickProducent ------");
      this.$store.commit("products/SET_VAR_STATE", [
        this.inputFields.producent,
        "inputData",
        "producent",
      ]);
      this.$store.commit("products/SET_VAR_STATE", [
        null,
        "inputData",
        "model",
      ]);
    },
    clickCentrale(e) {
      console.log("------ clickCentrale ------");
      // console.log(this.inputFields.centrala)

      console.log('------- setCentrala -------')
      const idEnclousers = (this.selectedObudowa) ? this.selectedObudowa.id_obudowa : []
      const idModules = Object.keys(this.inputFields.moduly).length > 0 ? this.inputFields.moduly.map((modules) => modules.idmodul) : []
      const idCentral = (this.inputFields.centrala && Object.keys(this.inputFields.centrala).length > 0) ? this.inputFields.centrala.idcentrala : []
      this.$store.dispatch("products/get_selected_elements", {centrala: idCentral, moduly: idModules, obudowa: idEnclousers})
    },
    clickModul() {
      console.log("------ clickModul ------");
      const idEnclousers = (this.selectedObudowa) ? this.selectedObudowa.id_obudowa : []
      const idModules = Object.keys(this.inputFields.moduly).length > 0 ? this.inputFields.moduly.map((modules) => modules.idmodul) : []
      const idCentral = (this.inputFields.centrala && Object.keys(this.inputFields.centrala).length > 0) ? this.inputFields.centrala.idcentrala : []
      this.$store.dispatch("products/get_selected_elements", { centrala: idCentral, moduly: idModules, obudowa: idEnclousers});
    },
    addModul() {
      if (this.countBoxModules === 4) {
      } else {
        this.countBoxModules++;
      }
      console.log("------ addModul ------");
    },
    deleteModul() {
      if (this.countBoxModules === 1) {
      } else {
        if (Object.keys(this.inputFields.moduly).length > 1) {
          this.inputFields.moduly.pop();
          this.clickModul();
        }
        this.countBoxModules--;
      }
      console.log("------ deleteModul ------");
    },
    // =============================================== Old
    setObudowa() {
      console.log('------ setObudowa ------')
      this.$store.dispatch("products/get_selected_elements", {centrala: [], moduly: [], obudowa: this.selectedObudowa.id_obudowa})
      .then( (elem) => {
        this.$store.dispatch("products/load_centrale", { obudowa: {'idsymbol': this.selectedObudowa.id_obudowa}, producent: this.inputFields.centrala.producent  })
        this.$store.dispatch("products/load_moduly", { obudowa: [this.selectedObudowa.id_obudowa], producent: this.inputFields.centrala.producent })
      })
    },
    setCentrala() {
      console.log('------ setCentrala ------')
      const idEnclousers = (this.selectedObudowa) ? this.selectedObudowa.id_obudowa : [];
      const idModules = Object.keys(this.inputFields.moduly).length > 0 ? this.inputFields.moduly.map((modules) => modules.idmodul) : [];
      const idCentral = (this.inputFields.centrala && Object.keys(this.inputFields.centrala).length > 0) ? this.inputFields.centrala.idcentrala : []
      this.$store.dispatch("products/get_selected_elements", {centrala: idCentral, moduly: idModules, obudowa: idEnclousers})
    },
    setModuly () {
      const idEnclousers = (this.selectedObudowa) ? this.selectedObudowa.id_obudowa : [];
      const idModules = Object.keys(this.inputFields.moduly).length > 0 ? this.inputFields.moduly.map((modules) => modules.idmodul) : [];
      const idCentral = (this.inputFields.centrala && Object.keys(this.inputFields.centrala).length > 0) ? this.inputFields.centrala.idcentrala : []
      this.$store.dispatch("products/get_selected_elements", { centrala: idCentral, moduly: idModules, obudowa: idEnclousers});
    },
    getObudowy() {
      this.$store.dispatch("products/load_obudowy_short", { centrala: [], obudowa: [] })
      .then((elem) => {

        if (this.$route.query.symbol && this.$route.query.symbol !== '') {
          this.getParamRoute(this.$route.query.symbol)
        }

        // let idEnclousers = Object.keys(elem).length > 0 ? elem.map((enclosure) => elem.id_obudowa) : [];
      });
    },
    getParamRoute (symbol) {
      var routeObudowa = this.obudowy.filter(item => (item.symbol === symbol))
      this.selectedObudowa = JSON.parse(JSON.stringify(routeObudowa[0]))
      this.setObudowa()
    },
    zmienWidok (el) {
      this.widok = el
      this.widokBtn = true
    }
  },
  // mounted() {
  //   console.log("------ mounted ------")
  // },
  created() {
    console.log("------ created ------")
    this.widok = 'C'
    this.widokBtn = false
    this.selectedObudowa = [];
    this.$store.dispatch("products/get_selected_elements", []);
    this.getObudowy();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>


h3 {
  margin: 15px;
font-size: 22px;
}
.kolumna-1 {
  width: 32%;
  padding: 10px;
  min-width: 336px;
  /* border-right: 3px solid #448aff;
  border-top: 3px solid #448aff; */
}
.kolumna-2 {
  /* background-color: #fff; */
  min-width: 336px;
  width: 68%;
  padding: 10px;
  /* border-top: 3px solid #448aff; */
}
.kolumna-21 {
  width: 100%;
  padding: 10px;
  min-width: 336px;
  /* border-right: 0px solid #448aff;
  border-top: 3px solid #448aff; */
}
.md-layout-item {
  margin-top: 15px;
}

fieldset {
  border: 1px solid grey;
  margin: 10px;
  padding: 8px;
  margin-top: 30px;
}
fieldset legend {
  font-size: 16px;
  background: #e6e4e4;
  margin-top: -18px;
  text-align: left;
  padding: 0px 10px;
}
fieldset legend img {
  cursor: pointer;
}
.inputSelectProducent {
  background: rgba(242, 242, 242, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelectCentrala {
  background: rgba(255, 0, 0, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelect0 {
  background: rgba(64, 82, 182, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelect1 {
  background: rgba(77, 177, 79, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelect2 {
  background: rgba(255, 192, 9, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelect3 {
  background: rgba(116, 85, 75, 0.5);
  padding: 5px;
  width: 240px;
}
.inSelect {
  position: relative;
}
.oko {
  position: absolute;
  right: 0px;
  top: 15px;
}
.navView {
list-style: none;display: inline-flex;margin: 0px;padding: 0px;
}
.navView li {
width: 100px;padding: 2px;margin-right: 10px;cursor: pointer;border: 1px solid #d0cfcf;
}
.navView li:hover {
  border: 1px solid #aaaaaa;
}
.activeView {
background: #d0d0d0;
}
</style>



// WEBPACK FOOTER //
// src/components/DopasujCentrale.vue